import React from "react";
import { Link } from "react-router-dom";

import "./Tabs.css";

/* eslint-disable jsx-a11y/anchor-is-valid */
const Tabs = ({ tabs, onChange = () => {}, activeTab, user_data }) => {
  return (
    <ul className="nav nav-tabs pl-2">
      {tabs.map(tab => (
        <Link className="link" to={tab?.to}>
          <li className="nav-item">
            <a
              className={`nav-link pb-4 ${tab.name === activeTab && "active"}`}
              data-toggle="tab"
              onClick={() => onChange(tab.name)}
            >
              {tab.value}
              {user_data?.chat_notify?.is_chat_listen &&
                tab.value == "Appointments" && (
                  <span
                    className="is-dot-icon mb-0"
                    style={{ marginTop: "11px" }}
                  />
                )}
            </a>
          </li>
        </Link>
      ))}
    </ul>
  );
};

export default Tabs;
